module.exports = __webpack_public_path__ + "img/mobile_banner_merchantServices.365531bd.png";